export default "__VITE_ASSET__c01dbb60__"